<label>
  {{ 'reward.status.coming.soon' | translate }}
</label>
<fgbcl-countdown-v2 [startDateTime]="startDate" [endDateTime]="comingSoonDate" (complete)="itemStart.emit()">
</fgbcl-countdown-v2>
